import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import TrustDetailsForm from './TrustDetailsForm';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import schema from 'react/shared/utils/schemas';
import WizardCard from 'react/signups/card/common/WizardCard';
import addressShape from 'react/signups/card/shapes/AddressShape';
import trustDetailsShape from 'react/signups/card/shapes/TrustDetails';

export default function ClientTrustDetails({
  moduleComplete,
  trustDetails,
  setTrustDetails,
  organizationName,
  organizationAddress,
}) {
  const validationSchema = Yup.object().shape({
    trusteeCategory: Yup.string().required('Please select one of the options'),
    titleIncludedInList: Yup.string().when('trusteeCategory', {
      is: (val) => val != 'An individual or sole proprietorship',
      then: () => Yup.string().required('Please select one of the options'),
    }),
    trusteeTitle: Yup.string().when('titleIncludedInList', {
      is: 'no',
      then: () => Yup.string().required('Please enter a title'),
    }),
    trusteeName: Yup.string()
      .when('businessIsTrustee', {
        is: false,
        then: () => Yup.string().required('Please enter a name'),
      })
      .when('trusteeCategory', {
        is: 'An individual or sole proprietorship',
        then: () => Yup.string().required('Please enter a name'),
      }),
    trustName: Yup.string().required('Please enter a trust name'),
    address: Yup.object().when('businessIsTrustee', {
      is: false,
      then: () => schema.address.required(),
    }),
  });

  const handleContinue = (values) => {
    setTrustDetails({
      trusteeCategory: values.trusteeCategory,
      businessIsTrustee: values.businessIsTrustee,
      titleIncludedInList: values.titleIncludedInList,
      trusteeTitle: values.trusteeTitle,
      trusteeName: values.trusteeName,
      trustName: values.trustName,
      address: {
        street1: values.address.street1,
        street2: values.address.street2,
        city: values.address.city,
        state: values.address.state,
        zip: values.address.zip,
      },
    });
  };

  return (
    <>
      <WizardCard>
        <CardHeader>Share some information about the trust</CardHeader>
        <Formik
          initialValues={trustDetails}
          onSubmit={handleContinue}
          validationSchema={validationSchema}
        >
          {({ handleSubmit, values, setValues, handleChange, setFieldTouched, setFieldValue }) => (
            <>
              <TrustDetailsForm
                onChange={handleChange}
                organizationAddress={organizationAddress}
                organizationName={organizationName}
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
                setValues={setValues}
                values={values}
              />
              <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
            </>
          )}
        </Formik>
      </WizardCard>
    </>
  );
}

ClientTrustDetails.propTypes = {
  moduleComplete: PropTypes.bool.isRequired,
  setTrustDetails: PropTypes.func.isRequired,
  trustDetails: trustDetailsShape,
  organizationName: PropTypes.string,
  organizationAddress: addressShape,
};
